import { Tooltip as BaseTooltip } from "@chakra-ui/react";

export default BaseTooltip;
